import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ITaxListResponse } from '../models/taxes.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Get a list of taxes based upon the access list
 * 
 * @returns {Promise} the api response
 */
const GetTaxes = async (): Promise<ITaxListResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId, accessList } = useAuth()!;

    const partnerIdList = accessList.map((element: any) => element.id).join(',');

    const { data } = await awsApiInstance.get('/taxes', {
      params: {
        partnerID: partnerIdList,
        wpID: userId,
        taxID: 0
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting tax data');
    throw(error);
  }
}

export default GetTaxes;